export const goTogetherDescription =
  'Assign reports to a case manager only if the same alleged offender is mentioned by another reporter';

export const unavailableTooltip =
  'Currently unavailable in your plan. Contact customer support for package upgrades or to explore add-ons to boost your business efficiency.';

export const flowBlockedByLinkedFormTooltip =
  'This category has a linked form that is not yet archived. Archive the linked form in Forms management before switching to default questions.';

export const customIntakeMethodUnavailableTooltip =
  'Custom questions are not yet available for VaultTalk and Slack intake channels — coming soon.';
